import { render, staticRenderFns } from "./ButtonNewPayment.vue?vue&type=template&id=68ac6c2c"
import script from "./ButtonNewPayment.vue?vue&type=script&lang=ts"
export * from "./ButtonNewPayment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports